import React from "react"
import Button from "@kit/design/button"
import Card from "@kit/design/card"
import calloutMap from "app/navigation/utils/callout-map"

export default function MobileCtaNav({ userInfo }) {
  const [showCallout, calloutLink, calloutContent] = calloutMap(userInfo)

  return (
    <React.Fragment>
      {showCallout && (
        <div className="bg-white p-3">
          <Card className="bg-blue-50">
            <h2 className="pb-2 font-semibold">{calloutContent["header"]}</h2>

            <div className="mb-5 text-gray-800 whitespace-pre-wrap">
              {calloutContent["text"]}
            </div>

            <Button is="primary" href={calloutLink}>
              {calloutContent["buttonText"]}
            </Button>
          </Card>
        </div>
      )}
    </React.Fragment>
  )
}
